var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoadLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Location",
    transform: "translate(-1045 -325)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 30,
    height: 30,
    transform: "translate(1045 325)",
    fill: "#13bcd4",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "maps-and-flags_1_",
    "data-name": "maps-and-flags (1)",
    transform: "translate(1051 327.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_996",
    "data-name": "Group 996",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3188",
    "data-name": "Path 3188",
    d: "M79.265,0a8.7,8.7,0,0,0-8.692,8.692c0,5.948,7.778,14.68,8.11,15.049a.783.783,0,0,0,1.165,0c.331-.369,8.11-9.1,8.11-15.049A8.7,8.7,0,0,0,79.265,0Zm0,13.065a4.373,4.373,0,1,1,4.373-4.373A4.378,4.378,0,0,1,79.265,13.065Z",
    transform: "translate(-70.573)",
    fill: "#13bcd4"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadLocation);
export default __webpack_public_path__ + "static/media/loadLocation.044bacf3f27bb79eca11eb09960a8297.svg";
export { ForwardRef as ReactComponent };